import React from "react";
import PreviousAdviceTableBody from "./PreviousAdviceTableBody";

const style = {
  tableHeader:
    "px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
};
const PreviousAdviceDetailsSection = ({
  combinedAdviceData,
  isLoading,
  exchange,
  getPageNumbers,
  goToPage,
  tabData,
}) => {
  return (
    <>
      {isLoading ? (
        <div className="flex items-center justify-center text-center font-bold text-xl md:text-3xl h-full">
          <div className="w-10 h-10 border-4 border-blue-[#2056DF] border-t-transparent rounded-full animate-spin" />
        </div>
      ) : combinedAdviceData?.length !== 0 ? (
        <div className="overflow-auto custom-scroll rounded-lg border border-gray-200 shadow-sm">
          <table className="w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className={style.tableHeader}>Date</th>
                <th className={style.tableHeader}>Symbol</th>
                <th className={style.tableHeader}>Type</th>
                <th className={style.tableHeader}>Exchnage</th>
                <th className={style.tableHeader}>price</th>
                <th className={style.tableHeader}>
                  <div className="w-[100px] overflow-auto break-words">
                    Order Type{" "}
                  </div>
                </th>
                <th className={style.tableHeader}>
                  {" "}
                  <div className="w-[100px] overflow-auto break-words">
                    Limit Price
                  </div>
                </th>
                <th className={style.tableHeader}>
                  <div className="w-[120px] overflow-auto break-words">
                    Product Type
                  </div>
                </th>
                <th className={style.tableHeader}>Segment</th>
                <th className={style.tableHeader}>Rationale</th>
                <th className={style.tableHeader}>comment</th>
                <th className={style.tableHeader}>comment2</th>
              </tr>
            </thead>
            {process.env.REACT_APP_PREVIOUS_ADVICE === "1" ? (
              <tbody className="bg-white divide-y divide-gray-200">
                {combinedAdviceData?.map((advice, adviceIndex) => {
                  return (
                    <PreviousAdviceTableBody
                      adviceIndex={adviceIndex}
                      advice={advice}
                    />
                  );
                })}
              </tbody>
            ) : (
              <tbody className="bg-white divide-y divide-gray-200">
                {combinedAdviceData?.map((item, rowIndex) => (
                  <React.Fragment key={item.id}>
                    {item?.advices
                      ?.filter((advice) => exchange.includes(advice?.exchange))
                      ?.sort(
                        (a, b) =>
                          new Date(b.date).getTime() -
                          new Date(a.date).getTime()
                      )
                      ?.map((advice, adviceIndex) => {
                        return (
                          <PreviousAdviceTableBody
                            adviceIndex={adviceIndex}
                            advice={advice}
                          />
                        );
                      })}
                  </React.Fragment>
                ))}
              </tbody>
            )}
          </table>
          {tabData.totalPages > 1 && (
            <div className="flex justify-center items-center pb-3 space-x-1">
              <button
                onClick={() => goToPage(tabData.currentPage - 1)}
                disabled={tabData.currentPage === 1}
                className="px-3 py-1 text-sm bg-gray-300 rounded disabled:opacity-50"
              >
                Previous
              </button>
              {getPageNumbers().map((page, index) =>
                page === "..." ? (
                  <span key={index} className="px-3 py-1 text-gray-600">
                    ...
                  </span>
                ) : (
                  <button
                    key={index}
                    onClick={() => goToPage(page)}
                    className={`px-3 py-1 text-sm rounded ${
                      page === tabData.currentPage
                        ? "bg-blue-500 text-white"
                        : "bg-gray-300"
                    }`}
                  >
                    {page}
                  </button>
                )
              )}
              <button
                onClick={() => goToPage(tabData.currentPage + 1)}
                disabled={tabData.currentPage === tabData.totalPages}
                className="px-3 py-1 text-sm bg-gray-300 rounded disabled:opacity-50"
              >
                Next
              </button>
            </div>
          )}
        </div>
      ) : (
        <div className="flex items-center justify-center text-center font-bold text-xl md:text-3xl h-full">
          No Data Available
        </div>
      )}
    </>
  );
};

export default PreviousAdviceDetailsSection;
